import {useState} from "react";
import {timeRanges} from "../../components/Charts/Helpers/timeRanges";
const defaultTimeRange = timeRanges.find((range) => range.value === "1d");

export const useHandleTimeRange = (openRangePicker) => {
  const [timeRangeOptions, setTimeRangeOptions] = useState([...timeRanges]);
  const [timeRangeStart, setTimeRangeStart] = useState(defaultTimeRange.value);
  const [timeRangeStop, setTimeRangeStop] = useState(undefined);
  const [windowPeriod, setWindowPeriod] = useState(defaultTimeRange.windowPeriod);

  const handleTimeRangeChange = (event) => {
    const {value} = event.target;
    if (value === "custom") {
      openRangePicker();
    } else {
      setTimeRangeStart(value);
      setTimeRangeOptions([...timeRanges]);
      const timeRange = timeRanges.find((range) => range.value === value);
      setWindowPeriod(timeRange.windowPeriod);
      setTimeRangeStop(undefined);
    }
  };

  const handleTimeRangeSave = (startDate, endDate, windowPeriod) => {
    setTimeRangeStart(startDate.toISOString());
    setTimeRangeStop(endDate.toISOString());
    setWindowPeriod(windowPeriod);

    const newTimeRangeLabel = `${startDate.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    })} - ${endDate.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    })}`;

    setTimeRangeOptions([
      ...timeRanges,
      {
        label: newTimeRangeLabel,
        value: startDate.toISOString(),
      },
    ]);
  };

  return {
    timeRangeOptions,
    timeRangeStart,
    timeRangeStop,
    windowPeriod,
    handleTimeRangeChange,
    handleTimeRangeSave,
  };
};
